export default __webpack_public_path__ + "631da9faf8e9f8c3a495815dddd7c23c.svg";